/**
 * Formats a value to a currency string.
 * i.e. 1234 => "$1,234.00"
 * @param value Number you want to display as a currency
 * @param fractions Number how precise your value should be
 * @returns A value in a currency string
 */
export const getCurrency = (value: number | string = 0, fractions = 0) => {
  return Number(value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: fractions,
    minimumFractionDigits: fractions,
  })
}
